import React from "react";

const LandingHero = ({ data = {} }) => {
  const {
    headline,
    list,
    des2,
    headlineAccent,
    description,
    buttons = [],
    badge = null,
    image = {},
  } = data;

  return (
    <section
      className="relative w-full primary-light-bg pt-0 pb-10 sm:pt-0  md:py-[16vh] lg:py-[16vh] xl:py-[24vh] overflow-visible"
      style={{
        backgroundImage: "url('/assets/home/homebg.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="mx-auto px-0   lg:px-[6vw] xl:px-[8vw] relative">
        <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-8 md:gap-10">
          {/* ── LEFT: Text Content ── */}
          <div className="flex-1 flex flex-col items-center lg:items-start w-full lg:max-w-[52%] relative z-10 px-4 md:px-[2.5vw] lg:px-[3vw] md:pt-14 lg:pt-0 text-center lg:text-left">
            {headline && (
              <h1 className="text-white font-medium mb-2">{headline}</h1>
            )}

            {headlineAccent && (
              <h2 className=" text-white font-bold leading-snug tracking-tight mb-5 md:mb-6">
                {headlineAccent}
              </h2>
            )}

            {description && (
              <p className="text-white leading-relaxed mb-7 lg:max-w-[500px]">
                {description}
              </p>
            )}

            {/* ── Buttons ── */}
            {buttons.length > 0 && (
              <div className="flex flex-wrap items-center gap-3 mb-5">
                {buttons.map((btn, i) =>
                  btn.variant === "outline" ? (
                    <a
                      key={i}
                      href={btn.href || "#"}
                      className="inline-flex items-center justify-cente btn btn-white whitespace-nowrap"
                    >
                      {btn.label}
                    </a>
                  ) : (
                    <a
                      key={i}
                      href={btn.href || "#"}
                      className="inline-flex items-center justify-center btn btn-primary whitespace-nowrap"
                    >
                      {btn.label}
                    </a>
                  ),
                )}
              </div>
            )}

            {des2 && (
              <p className="text-white leading-relaxed mb-3 lg:max-w-[530px]">
                {des2}
              </p>
            )}

            {list && (
              <>
                <div className={`text-center lg:text-left mt-3`}>
                  {list?.map((point, i) => {
                    const [main, ...rest] = point.split(" ");
                    const subText = rest.join(" ");

                    return (
                      <span
                        key={i}
                        className="px-2  md:px-2 lg:px-3 text-gray-700"
                      >
                        <span className="text-[15px] md:text-[17px]   font-normal  md:font-bold text-white">
                          {i !== 0 && (
                            <span className="md:mr-1 lg:mr-3 ">•</span>
                          )}
                          {main}
                        </span>{" "}
                        <span className="text-[12px] md:text-[13px] text-white">
                          {subText}
                        </span>
                      </span>
                    );
                  })}
                </div>
              </>
            )}
            <hr className="w-28 lg:w-72 h-[0.2vh] md:h-[0.15vh] bg-white border-0 mt-6  " />
            {/* <hr className="w-28 lg:w-72 h-[0.2vh] md:h-[0.15vh] bg-white border-0 mt-6 lg:ml-auto" /> */}
            {/* ── Badge ── */}
            {/* {badge?.text && (
              <div className="flex items-center gap-2 text-emerald-700 font-medium">
                <svg
                  className="w-[18px] h-[18px] flex-shrink-0 text-emerald-500"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="9 12 11 14 15 10" />
                </svg>
                <span className="text-emerald-500">{badge.text}</span>
              </div>
            )} */}
          </div>

          {/* ── RIGHT: Image (Mobile Normal) ── */}
          {image?.src && (
            <div className="w-full md:hidden">
              <img
                src={image.src}
                alt={image.alt || ""}
                className="w-full h-auto object-contain mt-16"
              />
            </div>
          )}
        </div>
      </div>

      {/* ── RIGHT: Image (Desktop Absolute Flush) ── */}
      {/* ── RIGHT: Image (Desktop Bottom Overflow Floating) ── */}
      {image?.src && (
        <div className="hidden lg:block absolute bottom-0 right-0 md:w-[40%] lg:w-[44%] xl:w-[40%] h-full overflow-visible pointer-events-none">
          <div className="relative w-full h-full flex items-end justify-center">
            {/* Floating wrapper */}
            <div className="relative lg:translate-y-10  xl:translate-y-14 transition-transform duration-500 ease-out hover:translate-y-16">
              <img
                src={image.src}
                alt={image.alt || "hero image"}
                className="w-full h-[115%] object-contain object-bottom scale-[1.08]"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default LandingHero;
